import Link from "../../Link";

const Express = () => {
    return (
        <div>
            <Link url="https://www.youtube.com/watch?v=1hpc70_OoAg" title={"Express y Node.js Desde 0 - FreeCodeCamp"} />
            <Link url="https://www.youtube.com/watch?v=JmJ1WUoUIK4" title={"Express para principiantes - Fazt"} />
        </div>
    );
}

export default Express;